import React, { useState, useEffect } from 'react';
import { MiniForm } from './Forms';
import { motion, AnimatePresence } from 'framer-motion';
import { X, MessageCircle } from 'lucide-react';

const StickyMiniForm = ({ sourcePage = '/' }) => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    const handler = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      setVisible(scrollPercent > 0.3);
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, [dismissed]);

  if (dismissed) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          className="fixed bottom-20 left-4 sm:left-6 z-40 w-80 max-w-[calc(100vw-3rem)]"
          data-testid="sticky-mini-form"
        >
          <div className="rounded-2xl bg-white border border-slate-200 shadow-[0_18px_48px_rgba(2,6,23,0.18)] overflow-hidden">
            <div className="flex items-center justify-between bg-[#0A2540] p-3">
              <span className="text-xs font-semibold text-white">Cotizar / Agendar Demo</span>
              <button onClick={() => setDismissed(true)} className="text-white/60 hover:text-white transition-colors">
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="p-4">
              <MiniForm sourcePage={sourcePage} />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyMiniForm;
